
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75 24a2.252 2.252 0 01-2.25-2.25V2.25A2.252 2.252 0 013.75 0h10.629c.601 0 1.165.234 1.59.658l5.872 5.872c.425.425.659.99.659 1.59v13.63A2.252 2.252 0 0120.25 24H3.75zm0-22.5a.75.75 0 00-.75.75v19.5c0 .414.336.75.75.75h16.5a.75.75 0 00.75-.75V9h-5.25a2.252 2.252 0 01-2.25-2.25V1.5H3.75zM15 6.75c0 .414.336.75.75.75h4.939L15 1.811V6.75z"}}),_c('path',{attrs:{"d":"M7.5 12a.75.75 0 01-.75-.75v-.353a2.983 2.983 0 01-1.705-1.099.746.746 0 01-.146-.555.745.745 0 01.742-.649c.233 0 .456.111.597.296a1.48 1.48 0 001.173.581l.059-.001c.775 0 1.343-.422 1.343-.798 0-.376-.562-.796-1.313-.796-1.551 0-2.812-1.031-2.812-2.298 0-1.052.849-1.943 2.062-2.213V3a.75.75 0 011.5 0v.355a2.979 2.979 0 011.705 1.097.745.745 0 01.146.555.745.745 0 01-.742.649.755.755 0 01-.598-.297 1.48 1.48 0 00-1.171-.58l-.059.001c-.775.001-1.343.422-1.343.798 0 .377.561.798 1.312.798 1.551 0 2.813 1.03 2.813 2.296 0 1.052-.85 1.943-2.063 2.213v.365a.75.75 0 01-.75.75zM5.75 21c-.689 0-1.25-.561-1.25-1.25v-5c0-.689.561-1.25 1.25-1.25h12.5c.689 0 1.25.561 1.25 1.25v5c0 .689-.561 1.25-1.25 1.25H5.75zM18 19.5V18h-3v1.5h3zm-4.5 0V18h-3v1.5h3zm-4.5 0V18H6v1.5h3zm9-3V15h-3v1.5h3zm-4.5 0V15h-3v1.5h3zm-4.5 0V15H6v1.5h3z"}})])
          )
        }
      }
    